export default "__VITE_ASSET__DeL8NcAu__"